function TerminosServicio() {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-xl border border-slate-200 dark:border-slate-700 overflow-hidden">
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 px-8 py-12 text-center">
            <h1 className="text-3xl lg:text-4xl font-bold text-white">Términos de Servicio</h1>
            <div className="w-24 h-1 bg-white/30 mx-auto mt-4 rounded-full"></div>
          </div>
          <div className="p-8 lg:p-12 space-y-8">
            <section className="border-b border-slate-200 dark:border-slate-700 pb-6">
              <h2 className="text-xl font-bold text-slate-900 dark:text-slate-100 mb-4">1. Aceptación de los Términos</h2>
              <p className="text-slate-600 dark:text-slate-300 leading-relaxed">Al utilizar los servicios de NeuroCrow, usted acepta estos términos en su totalidad. Estos términos establecen los derechos y responsabilidades entre su empresa y NeuroCrow.</p>
            </section>

            <section className="border-b border-slate-200 dark:border-slate-700 pb-6">
              <h2 className="text-xl font-bold text-slate-900 dark:text-slate-100 mb-4">2. Descripción del Servicio</h2>
              <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-4">NeuroCrow proporciona:</p>
              <ul className="space-y-2 text-slate-600 dark:text-slate-300">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Chatbots personalizados para atención al cliente</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Integración con Facebook Messenger, Instagram y WhatsApp Business</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Automatización de respuestas según sus necesidades</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Panel de control para gestión de conversaciones</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Análisis y reportes de interacciones</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Soporte técnico y mantenimiento</span>
                </li>
              </ul>
            </section>

            <section className="border-b border-slate-200 dark:border-slate-700 pb-6">
              <h2 className="text-xl font-bold text-slate-900 dark:text-slate-100 mb-4">3. Responsabilidades del Cliente</h2>
              <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-4">El cliente se compromete a:</p>
              <ul className="space-y-2 text-slate-600 dark:text-slate-300">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Proporcionar información precisa y actualizada</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Mantener la seguridad de sus credenciales de acceso</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>No usar el servicio para fines ilegales o no autorizados</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Respetar los términos de uso de Meta Platforms</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Mantener actualizada su información de contacto</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Notificar inmediatamente cualquier uso no autorizado</span>
                </li>
              </ul>
            </section>

            <section className="border-b border-slate-200 dark:border-slate-700 pb-6">
              <h2 className="text-xl font-bold text-slate-900 dark:text-slate-100 mb-4">4. Pagos y Facturación</h2>
              <ul className="space-y-2 text-slate-600 dark:text-slate-300">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Precios en pesos mexicanos (MXN)</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Facturación mensual</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Pagos no reembolsables</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Facturas conforme a leyes mexicanas</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Opciones de pago disponibles en México</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Cargos automáticos según plan elegido</span>
                </li>
              </ul>
            </section>

            <section className="border-b border-slate-200 dark:border-slate-700 pb-6">
              <h2 className="text-xl font-bold text-slate-900 dark:text-slate-100 mb-4">5. Cancelación y Terminación</h2>
              <ul className="space-y-2 text-slate-600 dark:text-slate-300">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Cancelación con 30 días de anticipación</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Sin penalización por cancelación con aviso</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Respaldo de datos disponible al terminar</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Período de gracia de 15 días</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Exportación de datos permitida</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Eliminación segura de información</span>
                </li>
              </ul>
            </section>

            <section className="border-b border-slate-200 dark:border-slate-700 pb-6">
              <h2 className="text-xl font-bold text-slate-900 dark:text-slate-100 mb-4">6. Disponibilidad del Servicio</h2>
              <ul className="space-y-2 text-slate-600 dark:text-slate-300">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>99.9% de tiempo de actividad garantizado</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Mantenimiento programado con aviso previo</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Soporte técnico en horario laboral</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Respuesta a emergencias 24/7</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Actualizaciones regulares del sistema</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Copias de seguridad diarias</span>
                </li>
              </ul>
            </section>

            <section className="border-b border-slate-200 dark:border-slate-700 pb-6">
              <h2 className="text-xl font-bold text-slate-900 dark:text-slate-100 mb-4">7. Limitación de Responsabilidad</h2>
              <ul className="space-y-2 text-slate-600 dark:text-slate-300">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Servicio proporcionado "tal cual"</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>No garantizamos resultados específicos</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Responsabilidad limitada a cuotas pagadas</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Excluimos daños indirectos</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Cliente responsable del contenido</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Cumplimiento de leyes aplicables</span>
                </li>
              </ul>
            </section>

            <section className="border-b border-slate-200 dark:border-slate-700 pb-6">
              <h2 className="text-xl font-bold text-slate-900 dark:text-slate-100 mb-4">8. Confidencialidad</h2>
              <ul className="space-y-2 text-slate-600 dark:text-slate-300">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Información del cliente estrictamente confidencial</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Protección de datos de usuarios finales</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>No divulgación a terceros sin autorización</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Acuerdos de confidencialidad disponibles</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Protección de secretos comerciales</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Medidas de seguridad empresarial</span>
                </li>
              </ul>
            </section>

            <section className="border-b border-slate-200 dark:border-slate-700 pb-6">
              <h2 className="text-xl font-bold text-slate-900 dark:text-slate-100 mb-4">9. Modificaciones del Servicio</h2>
              <ul className="space-y-2 text-slate-600 dark:text-slate-300">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Notificación previa de cambios importantes</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Derecho a actualizar funcionalidades</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Mejoras continuas del sistema</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Mantenimiento de versiones anteriores</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Compatibilidad garantizada</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Período de adaptación a cambios</span>
                </li>
              </ul>
            </section>

            <section className="border-b border-slate-200 dark:border-slate-700 pb-6">
              <h2 className="text-xl font-bold text-slate-900 dark:text-slate-100 mb-4">10. Ley Aplicable</h2>
              <ul className="space-y-2 text-slate-600 dark:text-slate-300">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Leyes de México</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Jurisdicción en Tijuana, B.C.</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Resolución amistosa de disputas</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Arbitraje como alternativa</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Cumplimiento de regulaciones locales</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Protección al consumidor</span>
                </li>
              </ul>
            </section>

            <section className="border-b border-slate-200 dark:border-slate-700 pb-6">
              <h2 className="text-xl font-bold text-slate-900 dark:text-slate-100 mb-4">Contacto</h2>
              <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-4">Para consultas sobre estos términos:</p>
              <ul className="space-y-2 text-slate-600 dark:text-slate-300">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Correo: legal@neurocrow.com</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Teléfono: +1 (619) 761-2314</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Dirección: Del Volcan, Tijuana, B.C.</span>
                </li>
              </ul>
            </section>

            <section>
              <p className="text-center text-sm text-slate-500 dark:text-slate-400 bg-slate-100 dark:bg-slate-700 rounded-lg py-3 px-4">Última actualización: 18 de Noviembre de 2024</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TerminosServicio; 